import React from "react";
import { Box, Center } from "@chakra-ui/react";
import { observer } from "mobx-react";
import { EmptyScreen } from "components";

export const EmptyLeadsTable = observer(() => {
  return (
    <Box
      display={"flex"}
      alignItems={"center"}
      minHeight={"100%"}
      bg={"gray.50"}
    >
      <Center width={"100%"} padding={5}>
        <EmptyScreen label={"No leads."} />
      </Center>
    </Box>
  );
});
